import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../api/AuthContext';

export const PrivateRoute: React.FC = () => {
    const { user, loading } = useAuth();

    if (loading) {
        // or a spinner
        return <div>Loading…</div>;
    }

    return user
        ? <Outlet />
        : <Navigate to="/login" replace />;
};
